.minimap {
  position: absolute;
  right: var(--chrome-inset);
  bottom: calc(64px + var(--safe-bottom));
  display: block;
  pointer-events: auto;
  background: var(--chrome);
  border: 1px solid var(--chrome-edge);
  border-radius: var(--radius-md);
  backdrop-filter: var(--chrome-blur);
  box-shadow: var(--elevation-2);
  cursor: crosshair;
  touch-action: none;
}
